module.exports = __webpack_public_path__ + "fonts/iconfont.07c13adc.eot";